
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vacantes",
      function () {
        return require("private-next-pages/vacantes/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vacantes"])
      });
    }
  